/* eslint-disable eqeqeq */
import { Avatar, Badge, Modal } from 'antd';
import { useContext, useState } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import CartIcon from '../../common/icons/CartIcon';
import HeartIcon from '../../common/icons/HeartIcon';
import SearchIcon from '../../common/icons/SearchIcon';
import UserContext from '../../contexts/user-context/UserProvider';
import userRouterLinks from '../app/user-routes/uesRouterLinks';
import { UserOutlined } from '@ant-design/icons';
import './FixedBottomHeaderMd.scss';
import routerLinks from '../app/routerLinks';
import accountTypes from '../../const-values/accountTypes';
import { useTranslation } from 'react-i18next';
import MainAppBarSearch from './MainAppBarSearch';
import useGeoLocation from '../../custom-hooks/useGeoLocation';
import AppNotificationsDropdownMenu from './AppNotificationsDropdownMenu';
import merchentRouterLinks from '../app/merchent-routes/merchentRouterLinks';
// import SettingsIcon from '../../common/icons/SettingsIcon';
import UserSettingsIcon from '../../common/icons/UserSettingsIcon';

const SearchModal = ({ modalOpened, setModalOpened }) => {
  const { i18n } = useTranslation();
  const location = useGeoLocation();

  return (
    <Modal
      wrapClassName="bottom-header-modal-wrapper"
      transitionName=""
      className={`bottom-header-modal shared-custom-modal ${i18n.dir()}`}
      width="100%"
      style={{ maxWidth: '694px' }}
      title=""
      open={modalOpened}
      onOk={() => {
        setModalOpened(false);
      }}
      onCancel={() => {
        setModalOpened(false);
      }}
      footer={false}
    >
      <MainAppBarSearch location={location} />
    </Modal>
  );
};

const FixedBottomHeaderMd = () => {
  const [searchModalOpened, setSearchModalOpened] = useState(false);
  const { user } = useContext(UserContext);
  const getProfileLink = () => {
    if (user) {
      if (user?.accountType == accountTypes()?.user) {
        return routerLinks?.userDashboard;
      } else if (
        user?.accountType == accountTypes()?.merchent ||
        user?.accountType == accountTypes()?.employee
      )
        return routerLinks?.merchentDashboard;
    }
    return routerLinks?.signinPage;
  };
  return (
    <>
      <div className="fixed-bottom-header">
        <div className="custom-container">
          <div className="links-list">
            <button
              onClick={() => {
                setSearchModalOpened(true);
              }}
              className="shared-nav-btn search-btn"
            >
              <SearchIcon color="#999" />
            </button>
            <RouterLink
              className="shared-nav-btn fav-btn"
              to={routerLinks?.myFavRoute}
            >
              <HeartIcon />
            </RouterLink>

            <div className="profile-placeholder"></div>
            <RouterLink
              to={getProfileLink()}
              className="profile-menu-btn"
              type="text"
            >
              <Avatar size={58} icon={<UserOutlined />} src={user?.image} />
            </RouterLink>

            {user?.accountType == accountTypes()?.merchent ||
            user?.accountType == accountTypes()?.employee ? (
              <RouterLink
                className="shared-nav-btn"
                to={merchentRouterLinks?.merchentSettings}
              >
                <UserSettingsIcon width={24} height={24} />
              </RouterLink>
            ) : (
              <RouterLink
                className="shared-nav-btn"
                to={userRouterLinks?.userCartRoute}
              >
                <CartIcon />
              </RouterLink>
            )}
            <div className="shared-nav-btn">
              <AppNotificationsDropdownMenu parentClassName="fixed-bottom-header" />
            </div>
          </div>
        </div>
      </div>

      {searchModalOpened && (
        <SearchModal
          modalOpened={searchModalOpened}
          setModalOpened={setSearchModalOpened}
        />
      )}
    </>
  );
};

export default FixedBottomHeaderMd;
